import { makeStyles } from '@material-ui/core';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export const useIntroPageStyles = makeStyles((theme) => ({
  sliderMarker: {
    color: 'rgba(255, 255, 255, 1)',
  },
}));
